export const FB_DIRECTIVES = [
  {
    "key": "siege-engine",
    "value": "Siege Engine"
  },
  {
    "key": "emplacement",
    "value": "Emplacement"
  },
  {
    "key": "ready",
    "value": "Ready"
  },
  {
    "key": "field-engineers",
    "value": "Field Engineers"
  },
  {
    "key": "loose",
    "value": "Loose!"
  },
  {
    "key": "take-cover",
    "value": "Take Cover!"
  },
  {
    "key": "all-hands",
    "value": "All Hands!"
  },
  {
    "key": "a-thousand-cuts",
    "value": "A Thousand-Cuts"
  },
  {
    "key": "accomplished-collegiate",
    "value": "Accomplished Collegiate"
  },
  {
    "key": "acolyte",
    "value": "Acolyte"
  },
  {
    "key": "adaptable-tactician",
    "value": "Adaptable Tactician"
  },
  {
    "key": "adept-archery",
    "value": "Adept Archery"
  },
  {
    "key": "aegyrson",
    "value": "Aegyrson"
  },
  {
    "key": "aetheric-blood",
    "value": "Aetheric Blood"
  },
  {
    "key": "aftershock",
    "value": "Aftershock"
  },
  {
    "key": "aggression-protocols",
    "value": "Aggression Protocols"
  },
  {
    "key": "aghm-above-all",
    "value": "Aghm Above All"
  },
  {
    "key": "aghm-is-eternal",
    "value": "Aghm is Eternal"
  },
  {
    "key": "agility",
    "value": "Agility"
  },
  {
    "key": "airship-bombardment",
    "value": "Airship Bombardment"
  },
  {
    "key": "akasha",
    "value": "Akasha"
  },
  {
    "key": "akshay-tunir",
    "value": "Akshay Tunir"
  },
  {
    "key": "alchemical-aggression",
    "value": "Alchemical Aggression"
  },
  {
    "key": "alea-iacta-est",
    "value": "Alea Iacta Est"
  },
  {
    "key": "ambuscade",
    "value": "Ambuscade"
  },
  {
    "key": "ambush",
    "value": "Ambush"
  },
  {
    "key": "anathema",
    "value": "Anathema"
  },
  {
    "key": "annihilation-protocols",
    "value": "Annihilation Protocols"
  },
  {
    "key": "arboreal-arborer",
    "value": "Arboreal Arborer"
  },
  {
    "key": "arcane-aptitude",
    "value": "Arcane Aptitude"
  },
  {
    "key": "arcane-armaments",
    "value": "Arcane Armaments"
  },
  {
    "key": "arena-champion",
    "value": "Arena Champion"
  },
  {
    "key": "armor-piercing",
    "value": "Armor Piercing X"
  },
  {
    "key": "army-of-lions",
    "value": "Army of Lions"
  },
  {
    "key": "army-rules-100k",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-dominion",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-dweghom",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-nords",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-sorcerers",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-spires",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-states",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-wadrhun",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-weavers",
    "value": "Army Rules"
  },
  {
    "key": "army-rules-yoroni",
    "value": "Army Rules"
  },
  {
    "key": "ascension",
    "value": "Ascension"
  },
  {
    "key": "aspect-of-cernunnos",
    "value": "Aspect of Cernunnos"
  },
  {
    "key": "aspect-of-the-avenger",
    "value": "Aspect of the Avenger"
  },
  {
    "key": "aspect-of-the-crow",
    "value": "Aspect of the Crow"
  },
  {
    "key": "aspect-of-the-redeemer",
    "value": "Aspect of the Redeemer"
  },
  {
    "key": "aspect-of-the-wolf",
    "value": "Aspect of the Wolf"
  },
  {
    "key": "astute-theologian",
    "value": "Astute Theologian"
  },
  {
    "key": "augmented-armaments",
    "value": "Augmented Armaments"
  },
  {
    "key": "aura-of-death",
    "value": "Aura of Death X"
  },
  {
    "key": "avalanche",
    "value": "Avalanche"
  },
  {
    "key": "avatar-of-war",
    "value": "Avatar of War"
  },
  {
    "key": "avatar-projection",
    "value": "Avatar Projection"
  },
  {
    "key": "avenging-angel",
    "value": "Avenging Angel"
  },
  {
    "key": "awaken",
    "value": "Awaken"
  },
  {
    "key": "awareness",
    "value": "Awareness"
  },
  {
    "key": "balance-of-power",
    "value": "Balance of Power"
  },
  {
    "key": "banshees-wail",
    "value": "Banshee's Wail"
  },
  {
    "key": "bardic-fortitude",
    "value": "Bardic Fortitude"
  },
  {
    "key": "barrage",
    "value": "Barrage X"
  },
  {
    "key": "bastion",
    "value": "Bastion"
  },
  {
    "key": "battle-hardened",
    "value": "Battle Hardened"
  },
  {
    "key": "battle-hymn",
    "value": "Battle Hymn"
  },
  {
    "key": "battlecry",
    "value": "Battlecry"
  },
  {
    "key": "battlefield-acumen",
    "value": "Battlefield Acumen"
  },
  {
    "key": "battlefield-orders",
    "value": "Battlefield Orders"
  },
  {
    "key": "battlesmith",
    "value": "Battlesmith"
  },
  {
    "key": "bavandar",
    "value": "Bavandar"
  },
  {
    "key": "beast-slayer",
    "value": "Beast Slayer"
  },
  {
    "key": "beast-tamer",
    "value": "Beast Tamer"
  },
  {
    "key": "behold-elysium",
    "value": "Behold Elysium"
  },
  {
    "key": "bellicosus",
    "value": "Bellicosus"
  },
  {
    "key": "berserker",
    "value": "Berserker"
  },
  {
    "key": "best-of-men",
    "value": "Best of Men"
  },
  {
    "key": "bestial-howl",
    "value": "Bestial Howl"
  },
  {
    "key": "bhaibandh",
    "value": "Bhaibandh"
  },
  {
    "key": "biochemical-detonation",
    "value": "Biochemical Detonation"
  },
  {
    "key": "biomantic-practitioner",
    "value": "Biomantic Practitioner"
  },
  {
    "key": "biotic-renewal",
    "value": "Biotic Renewal"
  },
  {
    "key": "blade-dancer",
    "value": "Blade-Dancer"
  },
  {
    "key": "blade-of-eakides",
    "value": "Blade of Eakides"
  },
  {
    "key": "bladestorm",
    "value": "Bladestorm"
  },
  {
    "key": "blasphemous-litany",
    "value": "Blasphemous Litany"
  },
  {
    "key": "blazing-conviction",
    "value": "Blazing Conviction"
  },
  {
    "key": "blazing-spirit",
    "value": "Blazing Spirit"
  },
  {
    "key": "blessed",
    "value": "Blessed"
  },
  {
    "key": "blessed-kalasha",
    "value": "Blessed Kalasha"
  },
  {
    "key": "blighted-pods",
    "value": "Blighted Pods"
  },
  {
    "key": "blizzard",
    "value": "Blizzard"
  },
  {
    "key": "bloodcurdling-roar",
    "value": "Bloodcurdling Roar"
  },
  {
    "key": "bloodlust",
    "value": "Bloodlust"
  },
  {
    "key": "bloodscent",
    "value": "Bloodscent"
  },
  {
    "key": "bloomshot",
    "value": "Bloomshot"
  },
  {
    "key": "bodyguard",
    "value": "Bodyguard"
  },
  {
    "key": "booming-diatribe",
    "value": "Booming Diatribe"
  },
  {
    "key": "born-of-fire",
    "value": "Born of Fire"
  },
  {
    "key": "born-of-shame",
    "value": "Born of Shame"
  },
  {
    "key": "boulder-toss",
    "value": "Boulder Toss"
  },
  {
    "key": "bound-to-the-elements",
    "value": "Bound to the Elements"
  },
  {
    "key": "bravery",
    "value": "Bravery"
  },
  {
    "key": "brazen-bulls",
    "value": "Brazen Bulls"
  },
  {
    "key": "brazen-phalera",
    "value": "Brazen Phalera"
  },
  {
    "key": "breath-of-unmaking",
    "value": "Breath of Unmaking"
  },
  {
    "key": "brutal",
    "value": "Brutal"
  },
  {
    "key": "bull-rush",
    "value": "Bull Rush"
  },
  {
    "key": "burnout",
    "value": "Burnout"
  },
  {
    "key": "burrowing-horror",
    "value": "Burrowing Horror"
  },
  {
    "key": "but-a-humble-servant",
    "value": "But a Humble Servant"
  },
  {
    "key": "cacophony",
    "value": "Cacophony"
  },
  {
    "key": "call-of-the-great-hall",
    "value": "Call of the Great Hall"
  },
  {
    "key": "call-the-hunt",
    "value": "Call the Hunt"
  },
  {
    "key": "campaign-veterans",
    "value": "Campaign Veterans"
  },
  {
    "key": "capricious",
    "value": "Capricious"
  },
  {
    "key": "carnage",
    "value": "Carnage"
  },
  {
    "key": "carnivorous",
    "value": "Carnivorous"
  },
  {
    "key": "castigation",
    "value": "Castigation"
  },
  {
    "key": "casus-belli",
    "value": "Casus Belli"
  },
  {
    "key": "cataclysm",
    "value": "Cataclysm"
  },
  {
    "key": "catechism-of-corruption",
    "value": "Catechism of Corruption"
  },
  {
    "key": "caustic-entrails",
    "value": "Caustic Entrails"
  },
  {
    "key": "ceaseless-march",
    "value": "Ceaseless March"
  },
  {
    "key": "ceaseless-salvo",
    "value": "Ceaseless Salvo"
  },
  {
    "key": "chainbreaker",
    "value": "Chainbreaker"
  },
  {
    "key": "charnel-ossuary",
    "value": "Charnel Ossuary"
  },
  {
    "key": "cheirosiphon",
    "value": "Cheirosiphōn"
  },
  {
    "key": "chikara-mizu",
    "value": "Chikara-Mizu"
  },
  {
    "key": "chitinous-onslaught",
    "value": "Chitinous Onslaught"
  },
  {
    "key": "chooser-of-the-slain",
    "value": "Chooser of the Slain"
  },
  {
    "key": "chosen-hunters",
    "value": "Chosen Hunters"
  },
  {
    "key": "chthonic-volition",
    "value": "Chthonic Volition"
  },
  {
    "key": "cleave",
    "value": "Cleave X"
  },
  {
    "key": "cloak-of-glamour",
    "value": "Cloak of Glamour"
  },
  {
    "key": "cloned-redundancy",
    "value": "Cloned Redundancy"
  },
  {
    "key": "cloying-thurible",
    "value": "Cloying Thurible"
  },
  {
    "key": "coat-of-arms",
    "value": "Coat of Arms"
  },
  {
    "key": "combat-directives",
    "value": "Combat Directives"
  },
  {
    "key": "combat-drills",
    "value": "Combat Drills"
  },
  {
    "key": "combat-tactician",
    "value": "Combat Tactician"
  },
  {
    "key": "combat-theologians",
    "value": "Combat Theologians"
  },
  {
    "key": "combined-arms",
    "value": "Combined Arms"
  },
  {
    "key": "compel",
    "value": "Compel"
  },
  {
    "key": "concentrated-thymos",
    "value": "Concentrated Thymos"
  },
  {
    "key": "conduit-colossus",
    "value": "Conduit Colossus"
  },
  {
    "key": "conflagrate",
    "value": "Conflagrate"
  },
  {
    "key": "consecrate",
    "value": "Consecrate"
  },
  {
    "key": "convulsive-scourge",
    "value": "Convulsive Scourge"
  },
  {
    "key": "coordinated-assault",
    "value": "Coordinated Assault"
  },
  {
    "key": "counter-attack",
    "value": "Counter-Attack"
  },
  {
    "key": "counter-charge",
    "value": "Counter Charge"
  },
  {
    "key": "court-scion",
    "value": "Court Scion"
  },
  {
    "key": "court-vizier",
    "value": "Court Vizier"
  },
  {
    "key": "crashing-tides",
    "value": "Crashing Tides"
  },
  {
    "key": "crescendo",
    "value": "Crescendo"
  },
  {
    "key": "crucible-of-war",
    "value": "Crucible of War"
  },
  {
    "key": "crypsis",
    "value": "Crypsis"
  },
  {
    "key": "crystaline-orrery",
    "value": "Crystaline Orrery"
  },
  {
    "key": "crystalline-chrysalis",
    "value": "Crystalline Chrysalis"
  },
  {
    "key": "cult-of-conquest",
    "value": "Cult of Conquest"
  },
  {
    "key": "cult-of-death",
    "value": "Cult of Death"
  },
  {
    "key": "cult-of-war",
    "value": "Cult of War"
  },
  {
    "key": "cultivated-muscle-memory",
    "value": "Cultivated Muscle Memory"
  },
  {
    "key": "dance-of-death",
    "value": "Dance of Death"
  },
  {
    "key": "dance-of-discord",
    "value": "Dance of Discord"
  },
  {
    "key": "dancing-flames",
    "value": "Dancing Flames"
  },
  {
    "key": "dancing-scimitar",
    "value": "Dancing Scimitar"
  },
  {
    "key": "dark-disciple",
    "value": "Dark Disciple"
  },
  {
    "key": "dark-menagerie",
    "value": "Dark Menagerie"
  },
  {
    "key": "dark-shepherd",
    "value": "Dark Shepherd"
  },
  {
    "key": "dark-supplication",
    "value": "Dark Supplication"
  },
  {
    "key": "dauntless",
    "value": "Dauntless"
  },
  {
    "key": "deadly-blades",
    "value": "Deadly Blades"
  },
  {
    "key": "deadly-shot",
    "value": "Deadly Shot"
  },
  {
    "key": "deafen",
    "value": "Deafen"
  },
  {
    "key": "death-and-despair",
    "value": "Death and Despair"
  },
  {
    "key": "deceive",
    "value": "Deceive"
  },
  {
    "key": "decimation",
    "value": "Decimation"
  },
  {
    "key": "decurion",
    "value": "Decurion"
  },
  {
    "key": "defense-of-lord-and-liege",
    "value": "Defense of Lord and Liege"
  },
  {
    "key": "defensive-formation",
    "value": "Defensive Formation"
  },
  {
    "key": "deft",
    "value": "Deft"
  },
  {
    "key": "degenerative-aura",
    "value": "Degenerative Aura"
  },
  {
    "key": "desecration",
    "value": "Desecration"
  },
  {
    "key": "designate-weakness",
    "value": "Designate Weakness"
  },
  {
    "key": "dheukorro-champion",
    "value": "Dheukorro Champion"
  },
  {
    "key": "dig-your-heels",
    "value": "Dig Your Heels"
  },
  {
    "key": "dismay",
    "value": "Dismay"
  },
  {
    "key": "divine-purpose",
    "value": "Divine Purpose"
  },
  {
    "key": "divine-strength",
    "value": "Divine Strength"
  },
  {
    "key": "divine-wind",
    "value": "Divine Wind"
  },
  {
    "key": "do-not-yield",
    "value": "Do Not Yield"
  },
  {
    "key": "dodge",
    "value": "Dodge"
  },
  {
    "key": "dominate",
    "value": "Dominate"
  },
  {
    "key": "dormant-realm",
    "value": "Dormant Realm"
  },
  {
    "key": "double-time",
    "value": "Double Time"
  },
  {
    "key": "draconic-rampage",
    "value": "Draconic Rampage"
  },
  {
    "key": "dragonbane",
    "value": "Dragonbane"
  },
  {
    "key": "dread",
    "value": "Dread"
  },
  {
    "key": "drop-anchor",
    "value": "Drop Anchor"
  },
  {
    "key": "dwerg-forged-plate",
    "value": "Dwerg-Forged Plate"
  },
  {
    "key": "dyad-training",
    "value": "Dyad Training"
  },
  {
    "key": "earth-element",
    "value": "Earth"
  },
  {
    "key": "earthen-fortitude",
    "value": "Earthen Fortitude"
  },
  {
    "key": "easy-prey",
    "value": "Easy Prey"
  },
  {
    "key": "eater-of-forms",
    "value": "Eater of Forms"
  },
  {
    "key": "ecclesiarch",
    "value": "Ecclesiarch"
  },
  {
    "key": "echoes-of-dheureghodh",
    "value": "Echoes of Dheureghodh"
  },
  {
    "key": "echoes-of-famine",
    "value": "Echoes of Famine"
  },
  {
    "key": "ekdromos",
    "value": "Ekdromos"
  },
  {
    "key": "elemental-assailment",
    "value": "Elemental Assailment"
  },
  {
    "key": "elemental-awakening",
    "value": "Elemental Awakening"
  },
  {
    "key": "elemental-blast",
    "value": "Elemental Blast"
  },
  {
    "key": "elemental-bolt",
    "value": "Elemental Bolt"
  },
  {
    "key": "elemental-cohort",
    "value": "Elemental Cohort"
  },
  {
    "key": "elemental-emissary",
    "value": "Elemental Emissary"
  },
  {
    "key": "elemental-enhancements",
    "value": "Elemental Enhancements"
  },
  {
    "key": "elemental-extoller",
    "value": "Elemental Extoller"
  },
  {
    "key": "elemental-vessel",
    "value": "Elemental Vessel"
  },
  {
    "key": "elusive",
    "value": "Elusive"
  },
  {
    "key": "elysian-fragment",
    "value": "Elysian Fragment"
  },
  {
    "key": "embolden",
    "value": "Embolden"
  },
  {
    "key": "enchant",
    "value": "Enchant"
  },
  {
    "key": "enigmatic-excellence",
    "value": "Enigmatic Excellence"
  },
  {
    "key": "eruption",
    "value": "Eruption"
  },
  {
    "key": "eternal-devotion",
    "value": "Eternal Devotion"
  },
  {
    "key": "eternal-mountain",
    "value": "Eternal Mountain"
  },
  {
    "key": "ethereal-mandate",
    "value": "Ethereal Mandate"
  },
  {
    "key": "ever-vigilant",
    "value": "Ever Vigilant"
  },
  {
    "key": "excommunicate",
    "value": "Excommunicate"
  },
  {
    "key": "executioner",
    "value": "Executioner"
  },
  {
    "key": "exertion",
    "value": "Exertion"
  },
  {
    "key": "exhilaration",
    "value": "Exhilaration"
  },
  {
    "key": "exhilaration-variant",
    "value": "Exhilaration"
  },
  {
    "key": "exhortation-of-eternal-faith",
    "value": "Exhortation of Eternal Faith"
  },
  {
    "key": "expert-scouts",
    "value": "Expert Scouts"
  },
  {
    "key": "eye-of-odin",
    "value": "Eye of Odin"
  },
  {
    "key": "eye-of-the-storm",
    "value": "Eye of the Storm"
  },
  {
    "key": "faith-and-fury",
    "value": "Faith and Fury"
  },
  {
    "key": "fanatical-devotion",
    "value": "Fanatical Devotion"
  },
  {
    "key": "fearless",
    "value": "Fearless"
  },
  {
    "key": "fearsome",
    "value": "Fearsome"
  },
  {
    "key": "feral",
    "value": "Feral"
  },
  {
    "key": "ferric-override",
    "value": "Ferric Override"
  },
  {
    "key": "ferric-thaumaturge",
    "value": "Ferric Thaumaturge"
  },
  {
    "key": "ferro-ossified-carapace",
    "value": "Ferro-Ossified Carapace"
  },
  {
    "key": "fervor",
    "value": "Fervor"
  },
  {
    "key": "fiend-hunter",
    "value": "Fiend Hunter"
  },
  {
    "key": "fight-as-one",
    "value": "Fight as One"
  },
  {
    "key": "fight-for-your-queen",
    "value": "Fight for your Queen"
  },
  {
    "key": "fight-in-the-shade",
    "value": "Fight in the Shade"
  },
  {
    "key": "fire-element",
    "value": "Fire"
  },
  {
    "key": "fire-lord",
    "value": "Fire Lord"
  },
  {
    "key": "fireball",
    "value": "Fireball"
  },
  {
    "key": "first-to-the-fray",
    "value": "First to the Fray"
  },
  {
    "key": "firstborn-of-war",
    "value": "Firstborn of War"
  },
  {
    "key": "flaming-dervish",
    "value": "Flaming Dervish"
  },
  {
    "key": "flank",
    "value": "Flank"
  },
  {
    "key": "flawless-strikes",
    "value": "Flawless Strikes"
  },
  {
    "key": "fleet-of-foot",
    "value": "Fleet of Foot"
  },
  {
    "key": "fleeting-flourish",
    "value": "Fleeting Flourish"
  },
  {
    "key": "flourish",
    "value": "Flourish"
  },
  {
    "key": "flow-of-battle",
    "value": "Flow of Battle"
  },
  {
    "key": "flurry",
    "value": "Flurry"
  },
  {
    "key": "fly",
    "value": "Fly"
  },
  {
    "key": "force-of-nature",
    "value": "Force of Nature"
  },
  {
    "key": "forced-assimilation",
    "value": "Forced Assimilation"
  },
  {
    "key": "forged-in-battle",
    "value": "Forged in Battle"
  },
  {
    "key": "forgemaster",
    "value": "Forgemaster"
  },
  {
    "key": "fragment-of-divinity",
    "value": "Fragment of Divinity"
  },
  {
    "key": "frenzied-miasma",
    "value": "Frenzied Miasma"
  },
  {
    "key": "frenzy",
    "value": "Frenzy"
  },
  {
    "key": "frigid-arrogance",
    "value": "Frigid Arrogance"
  },
  {
    "key": "frostbite",
    "value": "Frostbite"
  },
  {
    "key": "fruit-of-the-golden-tree",
    "value": "Fruit of the Golden Tree"
  },
  {
    "key": "fuelled-by-the-furnace",
    "value": "Fuelled by the Furnace"
  },
  {
    "key": "fungal-veil",
    "value": "Fungal Veil"
  },
  {
    "key": "fury",
    "value": "Fury"
  },
  {
    "key": "fury-of-the-legion",
    "value": "Fury of the Legion"
  },
  {
    "key": "fury-of-the-north",
    "value": "Fury of the North"
  },
  {
    "key": "fury-of-the-tribes",
    "value": "Fury of the Tribes"
  },
  {
    "key": "gale-rush",
    "value": "Gale Rush"
  },
  {
    "key": "gelid-gaoth",
    "value": "Gelid Gaoth"
  },
  {
    "key": "gift-of-fire",
    "value": "Gift of Fire"
  },
  {
    "key": "gift-of-magma",
    "value": "Gift of Magma"
  },
  {
    "key": "gift-of-stone",
    "value": "Gift of Stone"
  },
  {
    "key": "gifted-swordsman",
    "value": "Gifted Swordsman"
  },
  {
    "key": "gifts-of-the-glade",
    "value": "Gifts of the Glade"
  },
  {
    "key": "gilded-bulwark",
    "value": "Gilded Bulwark"
  },
  {
    "key": "glade-sentinels",
    "value": "Glade Sentinels"
  },
  {
    "key": "glade-warden",
    "value": "Glade Warden"
  },
  {
    "key": "glimmers-of-the-golden-age",
    "value": "Glimmers of the Golden Age"
  },
  {
    "key": "glorious-charge",
    "value": "Glorious Charge"
  },
  {
    "key": "gokudo",
    "value": "Gokudo"
  },
  {
    "key": "grafted-limb",
    "value": "Grafted Limb"
  },
  {
    "key": "grafted-limbs",
    "value": "Grafted Limbs"
  },
  {
    "key": "grim-determination",
    "value": "Grim Determination"
  },
  {
    "key": "grizzled",
    "value": "Grizzled"
  },
  {
    "key": "guardian-protocols",
    "value": "Guardian Protocols"
  },
  {
    "key": "guiding-winds",
    "value": "Guiding Winds"
  },
  {
    "key": "guile-of-loki",
    "value": "Guile of Loki"
  },
  {
    "key": "hardened",
    "value": "Hardened"
  },
  {
    "key": "harmony-through-dissonance",
    "value": "Harmony Through Dissonance"
  },
  {
    "key": "harvest",
    "value": "Harvest"
  },
  {
    "key": "hatchlings-of-omgorah",
    "value": "Hatchlings of Omgorah"
  },
  {
    "key": "hazlia-s-heralds",
    "value": "Hazlia's Heralds"
  },
  {
    "key": "healing-mists",
    "value": "Healing Mists"
  },
  {
    "key": "heat-of-the-moment",
    "value": "Heat of the Moment"
  },
  {
    "key": "hella-s-caress",
    "value": "Hella's Caress"
  },
  {
    "key": "helm-of-athrastia",
    "value": "Helm of Athrastia"
  },
  {
    "key": "henosis",
    "value": "Henosis"
  },
  {
    "key": "heriolfs-folly",
    "value": "Heriolf's Folly"
  },
  {
    "key": "hexxing-drouth",
    "value": "Hexxing Drouth"
  },
  {
    "key": "hierarchic-control Web",
    "value": "Hierarchic Control Web"
  },
  {
    "key": "hierarchic-control-web",
    "value": "Hierarchic Control Web"
  },
  {
    "key": "hircynes-hide",
    "value": "Hircyne's Hide"
  },
  {
    "key": "hive-mind",
    "value": "Hive Mind"
  },
  {
    "key": "hive-node",
    "value": "Hive Node"
  },
  {
    "key": "hoarfrost",
    "value": "Hoarfrost"
  },
  {
    "key": "hold-banners",
    "value": "Hold Banners"
  },
  {
    "key": "hold-chronicler",
    "value": "Hold Chronicler"
  },
  {
    "key": "hold-your-ground",
    "value": "Hold Your Ground!"
  },
  {
    "key": "holy-fervor",
    "value": "Holy Fervor"
  },
  {
    "key": "hone-blades",
    "value": "Hone Blades"
  },
  {
    "key": "honor-thy-order",
    "value": "Honor thy Order"
  },
  {
    "key": "honored-sashimono",
    "value": "Honored Sashimono"
  },
  {
    "key": "horticultural-hortator",
    "value": "Horticultural Hortator"
  },
  {
    "key": "howling-tempest",
    "value": "Howling Tempest"
  },
  {
    "key": "hunter-s-guile",
    "value": "Hunter's Guile"
  },
  {
    "key": "hunter-variant",
    "value": "Marksman Optimization Strain"
  },
  {
    "key": "hunters-quarry",
    "value": "Hunters Quarry"
  },
  {
    "key": "huntsman",
    "value": "Huntsman"
  },
  {
    "key": "hyperadrenal-stimulation",
    "value": "Hyperadrenal Stimulation"
  },
  {
    "key": "icarian-harness",
    "value": "Icarian Harness"
  },
  {
    "key": "ice-armor",
    "value": "Ice Armor"
  },
  {
    "key": "ice-warden",
    "value": "Ice Warden"
  },
  {
    "key": "iconoclast",
    "value": "Iconoclast"
  },
  {
    "key": "if-it-bleeds-we-can-kill-it",
    "value": "If it Bleeds, We Can Kill it"
  },
  {
    "key": "ignite",
    "value": "Ignite"
  },
  {
    "key": "ikken-hissatsu",
    "value": "Ikken Hissatsu"
  },
  {
    "key": "illusory-performance",
    "value": "Illusory Performance"
  },
  {
    "key": "imbue-blades",
    "value": "Imbue Blades"
  },
  {
    "key": "immolate",
    "value": "Immolate"
  },
  {
    "key": "immortal-will",
    "value": "Immortal Will"
  },
  {
    "key": "impact",
    "value": "Impact X"
  },
  {
    "key": "imperative-schema",
    "value": "Imperative Schema"
  },
  {
    "key": "imperator",
    "value": "Imperator"
  },
  {
    "key": "imperial-mandate",
    "value": "Imperial Mandate"
  },
  {
    "key": "in-the-presence-of-mnemancers",
    "value": "In the Presence of Mnemancers"
  },
  {
    "key": "incarnate-of-fire",
    "value": "Incarnate of Fire"
  },
  {
    "key": "incarnate-of-water",
    "value": "Incarnate of Water"
  },
  {
    "key": "incarnate-of-wind",
    "value": "Incarnate of Wind"
  },
  {
    "key": "indomitable",
    "value": "Indomitable"
  },
  {
    "key": "inevitable-advance",
    "value": "Inevitable Advance"
  },
  {
    "key": "inexorable",
    "value": "Inexorable"
  },
  {
    "key": "infernal-presence",
    "value": "Infernal Presence"
  },
  {
    "key": "infernal-rage",
    "value": "Infernal Rage"
  },
  {
    "key": "inferno",
    "value": "Inferno"
  },
  {
    "key": "inner-fire",
    "value": "Inner Fire"
  },
  {
    "key": "insatiable-anguish",
    "value": "Insatiable Anguish"
  },
  {
    "key": "insensate-to-pain",
    "value": "Insensate to Pain"
  },
  {
    "key": "inspiring-presence",
    "value": "Inspiring Presence"
  },
  {
    "key": "intercession",
    "value": "Intercession"
  },
  {
    "key": "intonjutsu",
    "value": "Intonjutsu"
  },
  {
    "key": "invictus",
    "value": "Invictus"
  },
  {
    "key": "inviolable-conviction",
    "value": "Inviolable Conviction"
  },
  {
    "key": "iron-discipline",
    "value": "Iron Discipline"
  },
  {
    "key": "iron-fortitude",
    "value": "Iron Fortitude"
  },
  {
    "key": "jadoo-kavach",
    "value": "Jadoo Kavach"
  },
  {
    "key": "jingasa-of-khanur",
    "value": "Jingasa of Khan’Ur"
  },
  {
    "key": "judge-not-the-innocent",
    "value": "Judge not the Innocent"
  },
  {
    "key": "juggernaut",
    "value": "Juggernaut"
  },
  {
    "key": "jury",
    "value": "Jury"
  },
  {
    "key": "kairos",
    "value": "Kairos"
  },
  {
    "key": "keeper-of-the-wooded-realm",
    "value": "Keeper of the Wooded Realm"
  },
  {
    "key": "kensei",
    "value": "Kensei"
  },
  {
    "key": "khecaratva",
    "value": "Khecaratva"
  },
  {
    "key": "kiss-of-the-dilosaur",
    "value": "Kiss of the Dilosaur"
  },
  {
    "key": "kitsunebi",
    "value": "Kitsunebi"
  },
  {
    "key": "kototamagaku",
    "value": "Kototamagaku"
  },
  {
    "key": "labarum-of-the-legion",
    "value": "Labarum of the Legion"
  },
  {
    "key": "labyrinthine-champion",
    "value": "Labyrinthine Champion"
  },
  {
    "key": "lamentation",
    "value": "Lamentation"
  },
  {
    "key": "lamp-of-dyelin",
    "value": "Lamp of Dyelin"
  },
  {
    "key": "lapis-manalis",
    "value": "Lapis Manalis"
  },
  {
    "key": "last-breath",
    "value": "Last Breath"
  },
  {
    "key": "lasting-legacy",
    "value": "Lasting Legacy"
  },
  {
    "key": "laurean-lance",
    "value": "Laurean Lance"
  },
  {
    "key": "leader",
    "value": "Leader"
  },
  {
    "key": "leap",
    "value": "Leap"
  },
  {
    "key": "legates-crest",
    "value": "Legate's Crest"
  },
  {
    "key": "lessons-of-the-jotun-war",
    "value": "Lessons of the Jotun War"
  },
  {
    "key": "lethal-compulsion",
    "value": "Lethal Compulsion"
  },
  {
    "key": "lethal-demise",
    "value": "Lethal Demise X"
  },
  {
    "key": "lethal-precision",
    "value": "Lethal Precision"
  },
  {
    "key": "lethality-protocols",
    "value": "Lethality Protocols"
  },
  {
    "key": "limbs-of-yggdrasill",
    "value": "Limbs of Yggdrasill"
  },
  {
    "key": "linebreaker",
    "value": "Linebreaker"
  },
  {
    "key": "lion-s-roar",
    "value": "Lion's Roar"
  },
  {
    "key": "lions-roar",
    "value": "Lion's Roar"
  },
  {
    "key": "living-arrows",
    "value": "Living Arrows"
  },
  {
    "key": "living-breastplate",
    "value": "Living Breastplate"
  },
  {
    "key": "living-legend",
    "value": "Living Legend"
  },
  {
    "key": "logistical-epoche",
    "value": "Logistical Epoche"
  },
  {
    "key": "lorekeeper",
    "value": "Lorekeeper"
  },
  {
    "key": "lorg-mor",
    "value": "Lorg Mór"
  },
  {
    "key": "maelstrom",
    "value": "Maelstrom"
  },
  {
    "key": "magma-element",
    "value": "Magma"
  },
  {
    "key": "magnanimity",
    "value": "Magnanimity"
  },
  {
    "key": "magus",
    "value": "Magus"
  },
  {
    "key": "malediction",
    "value": "Malediction"
  },
  {
    "key": "marble-masterwork",
    "value": "Marble Masterwork"
  },
  {
    "key": "marked-for-the-hunt",
    "value": "Marked for the Hunt"
  },
  {
    "key": "marksman-optimization-strain",
    "value": "Marksman Optimization Strain"
  },
  {
    "key": "martial-prowess",
    "value": "Martial Prowess"
  },
  {
    "key": "martial-tranquility",
    "value": "Martial Tranquility"
  },
  {
    "key": "martial-virtuoso",
    "value": "Martial Virtuoso"
  },
  {
    "key": "martyrdom",
    "value": "Martyrdom"
  },
  {
    "key": "master-conjurer",
    "value": "Master Conjurer"
  },
  {
    "key": "master-manipulator",
    "value": "Master Manipulator"
  },
  {
    "key": "masterwrought-blade",
    "value": "Masterwrought Blade"
  },
  {
    "key": "meltdown",
    "value": "Meltdown"
  },
  {
    "key": "memento-mori",
    "value": "Memento Mori"
  },
  {
    "key": "memories-of-the-forge",
    "value": "Memories of the Forge"
  },
  {
    "key": "mend-flesh",
    "value": "Mend Flesh"
  },
  {
    "key": "menticide",
    "value": "Menticide"
  },
  {
    "key": "messatsu",
    "value": "Messatsu"
  },
  {
    "key": "might-of-capitas",
    "value": "Might of Capitas"
  },
  {
    "key": "might-of-mannheim",
    "value": "Might of Mannheim"
  },
  {
    "key": "mimesis",
    "value": "Mimesis"
  },
  {
    "key": "mindless-vessel",
    "value": "Mindless Vessel"
  },
  {
    "key": "mischievous",
    "value": "Mischievous"
  },
  {
    "key": "mist-weave",
    "value": "Mist Weave"
  },
  {
    "key": "moaghm-dorh",
    "value": "Moaghm Dorh!"
  },
  {
    "key": "modus-operandi",
    "value": "Modus Operandi"
  },
  {
    "key": "molon-labe",
    "value": "Molon Labe"
  },
  {
    "key": "molten-domain",
    "value": "Molten Domain"
  },
  {
    "key": "molten-invocation",
    "value": "Molten Invocation"
  },
  {
    "key": "momentum",
    "value": "Momentum"
  },
  {
    "key": "mubarizun",
    "value": "Mubarizun"
  },
  {
    "key": "murderous-volley",
    "value": "Murderous Volley"
  },
  {
    "key": "myrmidons",
    "value": "Myrmidons"
  },
  {
    "key": "mystic-barrage",
    "value": "Mystic Barrage"
  },
  {
    "key": "mystic-shot",
    "value": "Mystic Shot"
  },
  {
    "key": "mystic-warrior",
    "value": "Mystic Warrior"
  },
  {
    "key": "natural-order",
    "value": "Natural Order"
  },
  {
    "key": "nemesis-stimuli",
    "value": "Nemesis Stimuli"
  },
  {
    "key": "neural-link",
    "value": "Neural Link"
  },
  {
    "key": "ningyo-johruri",
    "value": "Ningyo Johruri"
  },
  {
    "key": "ninjutsu",
    "value": "Ninjutsu"
  },
  {
    "key": "niyantran",
    "value": "Niyantran"
  },
  {
    "key": "nowhere-to-hide",
    "value": "Nowhere to Hide"
  },
  {
    "key": "nowhere-to-hide-wadrhun",
    "value": "Nowhere to Hide"
  },
  {
    "key": "nullify",
    "value": "Nullify"
  },
  {
    "key": "oath-of-solitude",
    "value": "Oath of Solitude"
  },
  {
    "key": "obedience",
    "value": "Obedience"
  },
  {
    "key": "oblivious",
    "value": "Oblivious"
  },
  {
    "key": "obsidian-impalement",
    "value": "Obsidian Impalement"
  },
  {
    "key": "occultist",
    "value": "Occultist"
  },
  {
    "key": "on-my-mark",
    "value": "On my Mark"
  },
  {
    "key": "on-the-prowl",
    "value": "On the Prowl"
  },
  {
    "key": "one-voice",
    "value": "One Voice"
  },
  {
    "key": "one-with-nothing",
    "value": "One with Nothing"
  },
  {
    "key": "opportunist",
    "value": "Opportunist"
  },
  {
    "key": "order-of-the-crimson-tower",
    "value": "Order of the Crimson Tower"
  },
  {
    "key": "order-of-the-sealed-temple",
    "value": "Order of the Sealed Temple"
  },
  {
    "key": "otherworldly-fury",
    "value": "Otherworldly Fury"
  },
  {
    "key": "overcharge",
    "value": "Overcharge"
  },
  {
    "key": "overrun",
    "value": "Overrun"
  },
  {
    "key": "overwhelm",
    "value": "Overwhelm"
  },
  {
    "key": "pack-hunters",
    "value": "Pack Hunters"
  },
  {
    "key": "pack-tactics",
    "value": "Pack Tactics"
  },
  {
    "key": "paragon",
    "value": "Paragon"
  },
  {
    "key": "parry",
    "value": "Parry"
  },
  {
    "key": "path-of-the-shuten-doji",
    "value": "Path of the Shuten-Doji"
  },
  {
    "key": "pavana",
    "value": "Pavana"
  },
  {
    "key": "pavise",
    "value": "Pavise"
  },
  {
    "key": "peerless-precision",
    "value": "Peerless Precision"
  },
  {
    "key": "penitence",
    "value": "Penitence"
  },
  {
    "key": "penitence-dominion",
    "value": "Penitence"
  },
  {
    "key": "phalanx",
    "value": "Phalanx"
  },
  {
    "key": "pheromantic-node",
    "value": "Pheromantic Node"
  },
  {
    "key": "phlogiston-projector",
    "value": "Phlogiston Projector"
  },
  {
    "key": "phlogiston-stimuli",
    "value": "Phlogiston Stimuli"
  },
  {
    "key": "phobos-axiom",
    "value": "Phobos Axiom"
  },
  {
    "key": "pike-formation",
    "value": "Pike Formation"
  },
  {
    "key": "pillage-and-plunder",
    "value": "Pillage and Plunder"
  },
  {
    "key": "pious-oration",
    "value": "Pious Oration"
  },
  {
    "key": "pontificate",
    "value": "Pontificate"
  },
  {
    "key": "practiced-manoeuvres",
    "value": "Practiced Manoeuvres"
  },
  {
    "key": "praefectus",
    "value": "Praefectus"
  },
  {
    "key": "precise-shot",
    "value": "Precise Shot"
  },
  {
    "key": "predatory-descent",
    "value": "Predatory Descent"
  },
  {
    "key": "predatory-pursuit",
    "value": "Predatory Pursuit"
  },
  {
    "key": "preservation-protocols",
    "value": "Preservation Protocols"
  },
  {
    "key": "press-the-attack",
    "value": "Press the Attack"
  },
  {
    "key": "preternatural-poise",
    "value": "Preternatural Poise"
  },
  {
    "key": "preternatural-vitality",
    "value": "Preternatural Vitality"
  },
  {
    "key": "pride-of-capitas",
    "value": "Pride of Capitas"
  },
  {
    "key": "primordial-awakening",
    "value": "Primordial Awakening"
  },
  {
    "key": "primordial-blast",
    "value": "Primordial Blast"
  },
  {
    "key": "primordial-bond",
    "value": "Primordial Bond"
  },
  {
    "key": "primordial-cannonade",
    "value": "Primordial Cannonade"
  },
  {
    "key": "primordial-dirge",
    "value": "Primordial Dirge"
  },
  {
    "key": "primordial-pact",
    "value": "Primordial Pact"
  },
  {
    "key": "primordial-vessel",
    "value": "Primordial Vessel"
  },
  {
    "key": "promachos",
    "value": "Promachos"
  },
  {
    "key": "pronunciation-weavers",
    "value": "How to Pronounce - Weaver Courts"
  },
  {
    "key": "pulpit",
    "value": "Pulpit"
  },
  {
    "key": "purebred-steed",
    "value": "Purebred Steed"
  },
  {
    "key": "purgation",
    "value": "Purgation"
  },
  {
    "key": "purity-of-form",
    "value": "Purity of Form"
  },
  {
    "key": "pyric-blast",
    "value": "Pyric Blast"
  },
  {
    "key": "pyromaniac",
    "value": "Pyromaniac"
  },
  {
    "key": "quicksilver-strikes",
    "value": "Quicksilver Strikes"
  },
  {
    "key": "quintessence",
    "value": "Quintessence"
  },
  {
    "key": "rage",
    "value": "Rage"
  },
  {
    "key": "rage-unbound",
    "value": "Rage Unbound"
  },
  {
    "key": "raging-pyre",
    "value": "Raging Pyre"
  },
  {
    "key": "raiding-party",
    "value": "Raiding Party"
  },
  {
    "key": "raise-shields",
    "value": "Raise Shields"
  },
  {
    "key": "rakan",
    "value": "Rakan"
  },
  {
    "key": "raking-claws",
    "value": "Raking Claws"
  },
  {
    "key": "rampant-growth",
    "value": "Rampant Growth"
  },
  {
    "key": "rapid-volley",
    "value": "Rapid Volley"
  },
  {
    "key": "rapture",
    "value": "Rapture"
  },
  {
    "key": "ravenous",
    "value": "Ravenous"
  },
  {
    "key": "reaping-blow",
    "value": "Reaping Blow"
  },
  {
    "key": "redoubled-efforts",
    "value": "Redoubled Efforts"
  },
  {
    "key": "reforge",
    "value": "Reforge"
  },
  {
    "key": "reform",
    "value": "Reform!"
  },
  {
    "key": "regeneration",
    "value": "Regeneration"
  },
  {
    "key": "reinforce",
    "value": "Reinforce"
  },
  {
    "key": "relentless",
    "value": "Relentless"
  },
  {
    "key": "relentless-blows",
    "value": "Relentless Blows"
  },
  {
    "key": "remembered",
    "value": "Remembered"
  },
  {
    "key": "rend",
    "value": "Rend"
  },
  {
    "key": "render-unto-hazlia",
    "value": "Render Unto Hazlia"
  },
  {
    "key": "reprocessing-agents",
    "value": "Reprocessing Agents"
  },
  {
    "key": "return-to-glory",
    "value": "Return to Glory"
  },
  {
    "key": "riddle-of-steel",
    "value": "Riddle of Steel"
  },
  {
    "key": "righteous-conquerors",
    "value": "Righteous Conquerors"
  },
  {
    "key": "rime-storm",
    "value": "Rime Storm"
  },
  {
    "key": "rise-to-the-challenge",
    "value": "Rise to the Challenge"
  },
  {
    "key": "ritual-drums",
    "value": "Ritual Drums"
  },
  {
    "key": "ritualist",
    "value": "Ritualist"
  },
  {
    "key": "roaring-waters",
    "value": "Roaring Waters"
  },
  {
    "key": "rousing-oration",
    "value": "Rousing Oration"
  },
  {
    "key": "ruination",
    "value": "Ruination"
  },
  {
    "key": "sacred-and-the-profane",
    "value": "Sacred and the Profane"
  },
  {
    "key": "sacrilegious-relic",
    "value": "Sacrilegious Relic"
  },
  {
    "key": "requiem",
    "value": "Requiem"
  },
  {
    "key": "sacrosanct",
    "value": "Sacrosanct"
  },
	{
    "key": "killshot",
    "value": "Killshot"
  },
  {
    "key": "sakkijutsu",
    "value": "Sakkijutsu"
  },
  {
    "key": "sanctify",
    "value": "Sanctify"
  },
  {
    "key": "savage-frenzy",
    "value": "Savage Frenzy"
  },
  {
    "key": "scars-of-endekar",
    "value": "Scars of Endekar"
  },
  {
    "key": "scavenged-bulwark",
    "value": "Scavenged Bulwark"
  },
  {
    "key": "scent-of-blood",
    "value": "Scent of Blood"
  },
  {
    "key": "scorch",
    "value": "Scorch"
  },
  {
    "key": "torrid-curse",
    "value": "Torrid Curse"
  },
  {
    "key": "scryer-of-runes",
    "value": "Scryer of Runes"
  },
  {
    "key": "searing-atgeirr",
    "value": "Searing Atgeirr"
  },
  {
    "key": "searing-dori",
    "value": "Searing Dori"
  },
  {
    "key": "seasoned-hunter",
    "value": "Seasoned Hunter"
  },
  {
    "key": "seismic-demise",
    "value": "Seismic Demise"
  },
  {
    "key": "sentinel-directives",
    "value": "Sentinel Directives"
  },
  {
    "key": "sept-scouts",
    "value": "Sept Scouts"
  },
  {
    "key": "sept-seneschal",
    "value": "Sept Seneschal"
  },
  {
    "key": "shadow-weave",
    "value": "Shadow-Weave"
  },
  {
    "key": "agnikand",
    "value": "Agnikand"
  },
  {
    "key": "shallal",
    "value": "Shallal"
  },
  {
    "key": "shard-of-vinda",
    "value": "Shard of Vinda"
  },
  {
    "key": "shield",
    "value": "Shield"
  },
  {
    "key": "shield-bash",
    "value": "Shield-Bash"
  },
  {
    "key": "shield-wall",
    "value": "Shield Wall"
  },
  {
    "key": "shieldmaidens",
    "value": "Shieldmaidens"
  },
  {
    "key": "shimenawa",
    "value": "Shimenawa"
  },
  {
    "key": "show-em-what-youre-made-of",
    "value": "Show 'em What You're Made Of!"
  },
  {
    "key": "shulaat",
    "value": "Shu'laat"
  },
  {
    "key": "sigils-of-binding",
    "value": "Sigils of Binding"
  },
  {
    "key": "signifer",
    "value": "Signifer"
  },
  {
    "key": "singing-bullets",
    "value": "Singing Bullets"
  },
  {
    "key": "singing-scythe",
    "value": "Singing Scythe"
  },
  {
    "key": "skirmishers",
    "value": "Skirmishers"
  },
  {
    "key": "skofnung",
    "value": "Skofnung"
  },
  {
    "key": "slain-bigger",
    "value": "Slain Bigger"
  },
  {
    "key": "slaking-maw",
    "value": "Slaking Maw"
  },
  {
    "key": "slayer-of-beasts",
    "value": "Slayer of Beasts"
  },
  {
    "key": "slicing-winds",
    "value": "Slicing Winds"
  },
  {
    "key": "smite",
    "value": "Smite"
  },
  {
    "key": "son-of-arnbjorn",
    "value": "Son of Arnbjörn"
  },
  {
    "key": "songs-of-sagas-and-steel",
    "value": "Songs of Sagas and Steel"
  },
  {
    "key": "sorcerous-amalgams",
    "value": "Sorcerous Amalgams"
  },
  {
    "key": "sorcerous-bolt",
    "value": "Sorcerous Bolt"
  },
  {
    "key": "sorcerous-conduit",
    "value": "Sorcerous Conduit"
  },
  {
    "key": "spearhead",
    "value": "Spearhead"
  },
  {
    "key": "spellcaster",
    "value": "Spellcaster X"
  },
  {
    "key": "spined-descent",
    "value": "Spined Descent"
  },
  {
    "key": "spirit-bond",
    "value": "Spirit Bond"
  },
  {
    "key": "spirit-guardian",
    "value": "Spirit Guardian"
  },
  {
    "key": "spirit-unbroken",
    "value": "Spirit Unbroken"
  },
  {
    "key": "spiritual-consort",
    "value": "Spiritual Consort"
  },
  {
    "key": "spoils-of-war",
    "value": "Spoils of War"
  },
  {
    "key": "stamina-of-thor",
    "value": "Stamina of Thor"
  },
  {
    "key": "stampede",
    "value": "Stampede"
  },
  {
    "key": "standard-bearer",
    "value": "Standard Bearer"
  },
  {
    "key": "standard-of-last-oration",
    "value": "Standard of Last Oration"
  },
  {
    "key": "stinging-salvo",
    "value": "Stinging Salvo"
  },
  {
    "key": "stone-embrace",
    "value": "Stone Embrace"
  },
  {
    "key": "stone-stampede",
    "value": "Stone Stampede"
  },
  {
    "key": "stories-yet-untold",
    "value": "Stories Yet Untold"
  },
  {
    "key": "strength-of-the-einherjar",
    "value": "Strength of the Einherjar"
  },
  {
    "key": "strength-of-the-herd",
    "value": "Strength of the Herd"
  },
  {
    "key": "strength-of-the-tribes",
    "value": "Strength of the Tribes"
  },
  {
    "key": "stubborn",
    "value": "Stubborn"
  },
  {
    "key": "student-of-war",
    "value": "Student of War"
  },
  {
    "key": "sultan-of-cinders",
    "value": "Sultan of Cinders"
  },
  {
    "key": "sunder",
    "value": "Sunder"
  },
  {
    "key": "support",
    "value": "Support"
  },
  {
    "key": "suppress-receptors",
    "value": "Suppress Receptors"
  },
  {
    "key": "sureshot",
    "value": "Sureshot"
  },
  {
    "key": "surgical-afflictions",
    "value": "Surgical Afflictions"
  },
  {
    "key": "survival-instincts",
    "value": "Survival Instincts"
  },
  {
    "key": "swarm",
    "value": "Swarm"
  },
  {
    "key": "swarming-strikes",
    "value": "Swarming Strikes"
  },
  {
    "key": "sweeping-blow",
    "value": "Sweeping Blow"
  },
  {
    "key": "swift",
    "value": "Swift"
  },
  {
    "key": "symbiotic-command",
    "value": "Symbiotic Command"
  },
  {
    "key": "synthetic-ambrosia",
    "value": "Synthetic Ambrosia"
  },
  {
    "key": "tactical-automatons",
    "value": "Tactical Automatons"
  },
  {
    "key": "take-root",
    "value": "Take Root"
  },
  {
    "key": "talisman-of-hormus",
    "value": "Talisman of Hormus"
  },
  {
    "key": "targe-of-hildisvini",
    "value": "Targe of Hildisvíni"
  },
  {
    "key": "target-priority",
    "value": "Target Priority"
  },
  {
    "key": "taurian-xiphos",
    "value": "Taurian Xiphos"
  },
  {
    "key": "tears-of-erme",
    "value": "Tears of Erme"
  },
  {
    "key": "temper-plate",
    "value": "Temper Plate"
  },
  {
    "key": "tempered-goad",
    "value": "Tempered Goad"
  },
  {
    "key": "tempo",
    "value": "Tempo"
  },
  {
    "key": "tenacious",
    "value": "Tenacious"
  },
  {
    "key": "tenebral-blade",
    "value": "Tenebral Blade"
  },
  {
    "key": "terrifying",
    "value": "Terrifying"
  },
  {
    "key": "terrifying-temptress",
    "value": "Terrifying Temptress"
  },
  {
    "key": "tessenjutsu",
    "value": "Tessenjutsu"
  },
  {
    "key": "test-of-faith",
    "value": "Test of Faith"
  },
  {
    "key": "test-of-honor",
    "value": "Test of Honor"
  },
  {
    "key": "testudo",
    "value": "Testudo"
  },
  {
    "key": "thakur",
    "value": "Thakur"
  },
  {
    "key": "the-first-blessing",
    "value": "The First Blessing"
  },
  {
    "key": "the-golden-apple",
    "value": "The Golden Apple"
  },
  {
    "key": "the-hidden-fang",
    "value": "The Hidden Fang"
  },
  {
    "key": "the-mountain-stands",
    "value": "The Mountain Stands"
  },
  {
    "key": "the-pallid-paludamentum",
    "value": "The Pallid Paludamentum"
  },
  {
    "key": "the-reaping-crook",
    "value": "The Reaping Crook"
  },
  {
    "key": "the-strides-of-march",
    "value": "The Strides of March"
  },
  {
    "key": "theomachia",
    "value": "Theomachia"
  },
  {
    "key": "theos-vult",
    "value": "Theos Vult"
  },
  {
    "key": "thorned-lash",
    "value": "Thorned Lash"
  },
  {
    "key": "thrill-of-the-hunt",
    "value": "Thrill of the Hunt"
  },
  {
    "key": "thrill-of-the-kill",
    "value": "Thrill of the Kill"
  },
  {
    "key": "thunderstomp",
    "value": "Thunderstomp"
  },
  {
    "key": "til-valhalla",
    "value": "Til Valhalla"
  },
  {
    "key": "tip-of-the-spear",
    "value": "Tip of the Spear"
  },
  {
    "key": "titan-s-wrath",
    "value": "Titan's Wrath"
  },
  {
    "key": "to-arms",
    "value": "To Arms!"
  },
  {
    "key": "to-victory",
    "value": "To Victory!"
  },
  {
    "key": "torrential-fire",
    "value": "Torrential Fire"
  },
  {
    "key": "scorching-visage",
    "value": "Scorching Visage"
  },
  {
    "key": "toxin-accumulator",
    "value": "Toxin Accumulator"
  },
  {
    "key": "toxin-glands",
    "value": "Toxin Glands"
  },
  {
    "key": "trample",
    "value": "Trample"
  },
  {
    "key": "trance",
    "value": "Trance"
  },
  {
    "key": "transubstantiation",
    "value": "Transubstantiation"
  },
  {
    "key": "tribal-leadership",
    "value": "Tribal Leadership"
  },
  {
    "key": "tribune",
    "value": "Tribune"
  },
  {
    "key": "tricks-of-the-trade",
    "value": "Tricks of the Trade"
  },
  {
    "key": "tricksters-shroud",
    "value": "Trickster's Shroud"
  },
  {
    "key": "tsujigiri",
    "value": "Tsujigiri"
  },
  {
    "key": "tsukitaoshi",
    "value": "Tsukitaoshi"
  },
  {
    "key": "tsunami-strike",
    "value": "Tsunami Strike"
  },
  {
    "key": "uaithnes-will",
    "value": "Uaithne's Will"
  },
  {
    "key": "ukunfazane-s-will",
    "value": "Ukunfazane's Will"
  },
  {
    "key": "unassailable-authority",
    "value": "Unassailable Authority"
  },
  {
    "key": "unbreakable",
    "value": "Unbreakable"
  },
  {
    "key": "unbroken",
    "value": "Unbroken"
  },
  {
    "key": "unchained",
    "value": "Unchained"
  },
  {
    "key": "undying-command",
    "value": "Undying Command"
  },
  {
    "key": "unholy-baptism",
    "value": "Unholy Baptism"
  },
  {
    "key": "unholy-sacrament",
    "value": "Unholy Sacrament"
  },
  {
    "key": "unleashed",
    "value": "Unleashed"
  },
  {
    "key": "unmake-armor",
    "value": "Unmake Armor"
  },
  {
    "key": "unrelenting-force",
    "value": "Unrelenting Force"
  },
  {
    "key": "unstable-enhancements",
    "value": "Unstable Enhancements"
  },
  {
    "key": "unstoppable",
    "value": "Unstoppable"
  },
  {
    "key": "unyielding",
    "value": "Unyielding"
  },
  {
    "key": "upheaval",
    "value": "Upheaval"
  },
  {
    "key": "urumi-of-alessa",
    "value": "Urumi of Alessa"
  },
  {
    "key": "valiant-charge",
    "value": "Valiant Charge"
  },
  {
    "key": "valor-of-tyr",
    "value": "Valor of Tyr"
  },
  {
    "key": "vanguard",
    "value": "Vanguard"
  },
  {
    "key": "venerable",
    "value": "Venerable"
  },
  {
    "key": "vengeance",
    "value": "Vengeance"
  },
  {
    "key": "vengeful-spirit",
    "value": "Vengeful Spirit"
  },
  {
    "key": "veni-vidi-vici",
    "value": "Veni Vidi Vici"
  },
  {
    "key": "verdant-boughs",
    "value": "Verdant Boughs"
  },
  {
    "key": "verdant-domain",
    "value": "Verdant Domain"
  },
  {
    "key": "verdant-vessel",
    "value": "Verdant Vessel"
  },
  {
    "key": "vessel-of-destruction",
    "value": "Vessel of Destruction"
  },
  {
    "key": "vexillum-dominus",
    "value": "Vexillum Dominus"
  },
  {
    "key": "viaticum",
    "value": "Viaticum"
  },
  {
    "key": "vigilance-of-heimdallr",
    "value": "Vigilance of Heimdallr"
  },
  {
    "key": "vigilant-guardian",
    "value": "Vigilant Guardian"
  },
  {
    "key": "violent-delirium",
    "value": "Violent Delirium"
  },
  {
    "key": "viridian-breath",
    "value": "Viridian Breath"
  },
  {
    "key": "viridian-quiver",
    "value": "Viridian Quiver"
  },
  {
    "key": "visceral-bombardment",
    "value": "Visceral Bombardment"
  },
  {
    "key": "visionary",
    "value": "Visionary"
  },
  {
    "key": "visions-of-ragnarok",
    "value": "Visions of Ragnarok"
  },
  {
    "key": "void-caller",
    "value": "Void Caller"
  },
  {
    "key": "volcanic-labrys",
    "value": "Volcanic Labrys"
  },
  {
    "key": "volcanic-retribution",
    "value": "Volcanic Retribution"
  },
  {
    "key": "volcanic-skorge",
    "value": "Volcanic Skorge"
  },
  {
    "key": "vortex",
    "value": "Vortex"
  },
  {
    "key": "war-s-anvil",
    "value": "War's Anvil"
  },
  {
    "key": "warborn",
    "value": "Warborn"
  },
  {
    "key": "warden-of-the-apocolypse",
    "value": "Warden of the Apocolypse"
  },
  {
    "key": "warding-glyphs",
    "value": "Warding Glyphs"
  },
  {
    "key": "warhorn",
    "value": "Warhorn"
  },
  {
    "key": "warpath",
    "value": "Warpath"
  },
  {
    "key": "warrior-scholar",
    "value": "Warrior Scholar"
  },
  {
    "key": "warriors-spirit",
    "value": "Warrior's Spirit"
  },
  {
    "key": "watchful-eye-of-the-high-kings",
    "value": "Watchful Eye of the High Kings"
  },
  {
    "key": "wayward-wanderer",
    "value": "Wayward Wanderer"
  },
  {
    "key": "weald-walker",
    "value": "Weald Walker"
  },
  {
    "key": "weapon-platform",
    "value": "Weapon Platform"
  },
  {
    "key": "web-of-lies",
    "value": "Web of Lies"
  },
  {
    "key": "wedge",
    "value": "Wedge"
  },
  {
    "key": "weeping-spores",
    "value": "Weeping Spores"
  },
  {
    "key": "well-regulated",
    "value": "Well Regulated"
  },
  {
    "key": "whispers-of-futility",
    "value": "Whispers of Futility"
  },
  {
    "key": "wind-lord",
    "value": "Wind Lord"
  },
  {
    "key": "winged-horror",
    "value": "Winged Horror"
  },
  {
    "key": "wisdom-of-the-elders",
    "value": "Wisdom of the Elders"
  },
  {
    "key": "witch-hunt",
    "value": "Witch Hunt"
  },
  {
    "key": "woodland-sentries",
    "value": "Woodland Sentries"
  },
  {
    "key": "wreathed-in-shadow",
    "value": "Wreathed in Shadow"
  },
  {
    "key": "written-in-stone",
    "value": "Written in Stone"
  },
  {
    "key": "zanshin",
    "value": "Zanshin"
  },
  {
    "key": "zealotry",
    "value": "Zealotry"
  },
  {
    "key": "kith-keeper",
    "value": "Kith Keeper"
  },
  {
    "key": "ard-tiarna",
    "value": "Ard Tiarna"
  },
  {
    "key": "sept-sire",
    "value": "Sept Sire"
  },
  {
    "key": "faerann-lord",
    "value": "Faerann Lord"
  },
  {
    "key": "realm-wrath",
    "value": "Realm Wrath"
  },
  {
    "key": "zulhanis-spear",
    "value": "Zu'lhani's Spear"
  },
  {
    "key": "reverberation",
    "value": "Reverberation"
  },
  {
    "key": "cull",
    "value": "Cull"
  },
  {
    "key": "alchemical-immolation",
    "value": "Alchemical Immolation"
  },
  {
    "key": "evanesce",
    "value": "Evanesce"
  },
  {
    "key": "gallantry",
    "value": "Gallantry"
  },
  {
    "key": "flaith-laoch",
    "value": "Flaith Laoch"
  },
  {
    "key": "natural-predator",
    "value": "Natural Predator"
  },
  {
    "key": "esoteric-erosion",
    "value": "Esoteric Erosion"
  },
  {
    "key": "feth-fiada",
    "value": "Féth Fíada"
  },
  {
    "key": "prabal-pravaah",
    "value": "Prabal Pravaah"
  },
  {
    "key": "water-lord",
    "value": "Water Lord"
  },
  {
    "key": "jadugarni",
    "value": "Jadugarni"
  },
  {
    "key": "etheral-serenity",
    "value": "Etheral Serenity"
  },
  {
    "key": "oasis",
    "value": "Oasis"
  },
  {
    "key": "bhanwar",
    "value": "Bhanwar"
  },
  {
    "key": "soothing-tides",
    "value": "Soothing Tides"
  },
  {
    "key": "hold-paragon",
    "value": "Hold Paragon"
  },
  {
    "key": "daayan",
    "value": "Daayan"
  },
  {
    "key": "asuric-malevolence",
    "value": "Asuric Malevolence"
  },
  {
    "key": "jalapralaya",
    "value": "Jalapralaya"
  },
  {
    "key": "shukuchi",
    "value": "Shukuchi"
  },
  {
    "key": "hatamoto",
    "value": "Hatamoto"
  },
  {
    "key": "fury-of-the-storm",
    "value": "Fury of the Storm"
  },
  {
    "key": "mighty-steed",
    "value": "Mighty Steed"
  },
  {
    "key": "kyosenshi",
    "value": "Kyōsenshi"
  }
];
